import * as React from "react";
import { hot } from "react-hot-loader";
import { CSSTransition } from 'react-transition-group';
import EnmUtils from '../../utils/EnmUtils';
import { IHomeState } from './IHomeState';
import CustomLoader from '../CustomLoader/CustomLoader';
import Presentation from './Presentation/Presentation';
import Candidatures from '../Candidatures/Candidatures';

class Home extends React.Component<{}, IHomeState> {

  constructor(props: any) {
    super(props);

    // Init du state
    this.state = {
      Ready: true,
      ConnectedLogin: EnmUtils.getLoginConnectedUser()
    };
  }

/*   public componentDidMount() {

    let connectedLogin = "";
    const connectedUserName = document.getElementById('aspConnectedUserName');

    if (connectedUserName != null) {
      connectedLogin = connectedUserName[this.valueKey].split('\\')[1];
    }

    this.setState({
      Ready: true,
      ConnectedLogin: connectedLogin
    })
  } */

  public render() {

    return (
      <div id="home">

        <CSSTransition
          classNames="loader"
          in={!this.state.Ready}
          timeout={300}
          unmountOnExit={true}
        >
          <CustomLoader />
        </CSSTransition>

        <CSSTransition
          classNames="fadein"
          in={this.state.Ready && this.state.ConnectedLogin === ''}
          timeout={300}
          unmountOnExit={true}
        >
          {/* Si pas de user authentifié > page presentation de l'app */}
          <Presentation />
        </CSSTransition>

        <CSSTransition
          classNames="fadein"
          in={this.state.Ready && this.state.ConnectedLogin !== ''}
          timeout={300}
          unmountOnExit={true}
        >
          {/* Si user authentifié > page de la liste des candidatures de l'utilisateur */}
          <Candidatures />
        </CSSTransition>

      </div>
    );
  }
}

export default hot(module)(Home);